// As part of @reach/router's baked-in accessibility features, the router will
// automatically focus the element `navigate()` has loaded, and browsers
// will scroll the focused element into view. This results in
// unpredictable behavior of the Church Center header that we'd like to avoid,
// so the route change worker is a workaround to keep the page scrolled to top
// after a `navigate()` action.
//
// So far, it doesn't sound like the reach folks think this is a bug or that
// they are interested in addressing in the library. ¯\_(ツ)_/¯
//
// https://github.com/reach/router/issues/62
// https://github.com/reach/router/issues/242

import { useLocation } from "react-router"
import { useUpdateEffect } from "./hooks/useUpdateEffect"

export default function ScrollToTopOnRouteChange({
  children,
}: {
  children: React.ReactNode
}) {
  const location = useLocation()
  useUpdateEffect(() => {
    window.scrollTo(0, 0)
  }, [location.pathname])

  return children
}
